import { db } from "../firebaseClient"
import { doc, setDoc, updateDoc, deleteDoc, collection, getDocs, serverTimestamp } from "firebase/firestore"

export const createLearningPath = async ({ orgId, title, description }) => {
  if (!orgId || !title?.trim()) {
    return { pathId: null, error: { message: "Title is required" } }
  }
  try {
    const pathRef = doc(collection(db, "organizations", orgId, "learningPaths"))
    await setDoc(pathRef, {
      title: title.trim(),
      description: description || "",
      status: "active",
      nodes: [],
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    })
    return { pathId: pathRef.id, error: null }
  } catch (error) {
    return { pathId: null, error }
  }
}

export const updateLearningPath = async (orgId, pathId, updates) => {
  try {
    await updateDoc(doc(db, "organizations", orgId, "learningPaths", pathId), {
      ...updates,
      updatedAt: serverTimestamp(),
    })
    return { error: null }
  } catch (error) {
    return { error }
  }
}

export const deleteLearningPath = async (orgId, pathId) => {
  try {
    await deleteDoc(doc(db, "organizations", orgId, "learningPaths", pathId))
    return { error: null }
  } catch (error) {
    return { error }
  }
}

export const listLearningPaths = async (orgId) => {
  try {
    const snap = await getDocs(collection(db, "organizations", orgId, "learningPaths"))
    return { paths: snap.docs?.map((d) => ({ pathId: d.id, ...d.data() })), error: null }
  } catch (error) {
    return { paths: [], error }
  }
}